import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-8194" data-mp="1s686kqt66m6k">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-8195" data-mp="1n86mq3nx6iu1">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-8196" data-mp="1e5p3ly3ka6b9">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-8197" data-mp="1e7ic7ixqj0lw">
            <ArrowLeft className="w-4 h-4" data-id="element-8198" data-mp="14gdw2fwbp9ph" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-8199" data-mp="zhu8yc5ztrvj">NOIZA</div>
          <div className="w-20" data-id="element-8200" data-mp="uhg9hiigjq94" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-8201" data-mp="qfl1xw9xogmw">
        <div className="mb-12" data-id="element-8202" data-mp="qigxjdyb6t86">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-8203" data-mp="1o9qftazox61">
            <FileText className="w-6 h-6 text-white/80" data-id="element-8204" data-mp="6g9xs6te2scn" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-8205" data-mp="3nwi0dn8idmy9">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-8206" data-mp="3svcj6p6h7bid">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-8207" data-mp="pevz9mstilh3">
          <section data-id="element-8208" data-mp="pc9ozfejlrv6">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8209" data-mp="beuye7cjze1m">
              <span className="text-[#006847]" data-id="element-8210" data-mp="fg6g7qp6quz9">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8211" data-mp="2w5238z9bshts">
              <p data-id="element-8212" data-mp="2w40vb3nlwbga">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-8213" data-mp="16pj3haibyvsy">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8214" data-mp="wwkcjlzd2t66">
                <li data-id="element-8215" data-mp="rzburmi4kr5g">Haber leído íntegramente este documento</li>
                <li data-id="element-8216" data-mp="rwy0hfv9riyy">Comprender su contenido en su totalidad</li>
                <li data-id="element-8217" data-mp="nxym74nne9uu">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-8218" data-mp="j0glu2np52yg">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-8219" data-mp="28bzaarze9p2c">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8220" data-mp="28cij9j72h348">
              <span className="text-[#006847]" data-id="element-8221" data-mp="23egy8sq2ytq4">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8222" data-mp="2bupoch6stzkg">
              <p data-id="element-8223" data-mp="2fwb90opkri57">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8224" data-mp="2fugmj5ynnhz0">
                <li data-id="element-8225" data-mp="2kokvfurhe02q">Software como servicio (SaaS)</li>
                <li data-id="element-8226" data-mp="2pmcv5aydaqhh">Marketplace digital gastronómico</li>
                <li data-id="element-8227" data-mp="2pluve4chxu4t">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8228" data-mp="1sxoi6t1idtex">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8229" data-mp="1wx5pzt4er2n9">
                <li data-id="element-8230" data-mp="1wzidsmwuk788">Mostrar su menú digital</li>
                <li data-id="element-8231" data-mp="21vqono40he9l">Recibir pedidos de clientes</li>
                <li data-id="element-8232" data-mp="21z4q8u4upjfz">Gestionar su operación interna</li>
                <li data-id="element-8233" data-mp="26wo4vv5gny8g">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8234" data-mp="3ia8s8grumkes">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8235" data-mp="q3rdtd3j5fk6">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8236" data-mp="q49jt1fzv85a">
              <span className="text-[#006847]" data-id="element-8237" data-mp="143sg8wzg0v1r">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8238" data-mp="z3ehy6nn8zgx">
              <p data-id="element-8239" data-mp="z6irljjvonez">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8240" data-mp="1dzvqkq4g7zzs">
                <li data-id="element-8241" data-mp="1935aw3wk36ew">No es proveedor de alimentos</li>
                <li data-id="element-8242" data-mp="1909bsc8z2bov">No participa en la preparación de productos</li>
                <li data-id="element-8243" data-mp="1msgz7ded8qaw">No manipula alimentos en ningún momento</li>
                <li data-id="element-8244" data-mp="1irn9cehd51fd">No realiza entregas ni logística</li>
                <li data-id="element-8245" data-mp="1iu9rt95sl1cd">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8246" data-mp="1wszl0dphqgvg">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8247" data-mp="1rtwh4wl8ygp2">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8248" data-mp="21gh9w04e7dif">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8249" data-mp="21gz1ukk0v5kj">
              <span className="text-[#006847]" data-id="element-8250" data-mp="26fadn0tvnq5e">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8251" data-mp="1snvsanchzcv6">
              <p data-id="element-8252" data-mp="1smufoefu2ibc">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8253" data-mp="1iqhlzgkag4gl">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8254" data-mp="1irixfm57usyu">
                <li data-id="element-8255" data-mp="1nq41xxri3yt3">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8256" data-mp="19orlll8fhv6o">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8257" data-mp="1dqd35jvwqxn7">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8258" data-mp="3bmtmp2ep60ie">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8259" data-mp="3blil998q54ug">
                <li data-id="element-8260" data-mp="36os5kn0u0b9k">Precios</li>
                <li data-id="element-8261" data-mp="36o0dvnacuxok">Menú</li>
                <li data-id="element-8262" data-mp="31onlyo4mn0f4">Horarios</li>
                <li data-id="element-8263" data-mp="31pp1p5wl8b36">Métodos de pago</li>
                <li data-id="element-8264" data-mp="31mkq3ngsmd2h">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8265" data-mp="34xkugu5rk2y">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8266" data-mp="3udbff6zj4w3r">
              <span className="text-[#006847]" data-id="element-8267" data-mp="3ubi8rrox2bvr">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8268" data-mp="3lcwptvfj8uug">
              <div data-id="element-8269" data-mp="3lbv6z4s9z426">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8270" data-mp="3lepp2pntgcsf">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8271" data-mp="29xpybyh4a60i">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8272" data-mp="thadr2m64f8w">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8273" data-mp="teo672za1zqo">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8274" data-mp="137vlbfjtku3y">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8275" data-mp="1866urp67d2ln">
                  <li data-id="element-8276" data-mp="1889iu3nsolnq">Calidad de los alimentos</li>
                  <li data-id="element-8277" data-mp="1d3ypss2594u2">Estado, frescura o preparación</li>
                  <li data-id="element-8278" data-mp="1h6lj6xegqxtd">Ingredientes utilizados</li>
                  <li data-id="element-8279" data-mp="1h7wmyx7ws5kh">Contaminación cruzada</li>
                  <li data-id="element-8280" data-mp="1m5pqfihtulh2">Problemas de higiene o salubridad</li>
                  <li data-id="element-8281" data-mp="1m56bmanh4d79">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8282" data-mp="3iyrng2d28sxj">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8283" data-mp="1tp7cb2ijnngs">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8284" data-mp="1tofjfzgc03u7">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8285" data-mp="1pn3za9g88ate">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8286" data-mp="1ygh2q5bx2utq">
                  <li data-id="element-8287" data-mp="1arec47zb1rn3">Retrasos en la entrega</li>
                  <li data-id="element-8288" data-mp="1as68vm4n1vey">Pérdida de pedidos</li>
                  <li data-id="element-8289" data-mp="16pjepekhvyel">Entregas incompletas</li>
                  <li data-id="element-8290" data-mp="16quhbb27f044">Errores en dirección</li>
                  <li data-id="element-8291" data-mp="1kosrs5demcec">Conducta de repartidores</li>
                  <li data-id="element-8292" data-mp="1kmg2f75bgzr9">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8293" data-mp="1fo4tqzqrcvam">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8294" data-mp="2w3pirkt5fboc">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8295" data-mp="2r54hdi25ulyb">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8296" data-mp="cz6is7ojtrgf">
                  <li data-id="element-8297" data-mp="hx85d2l6o8wn">Recepción de pagos</li>
                  <li data-id="element-8298" data-mp="3woy3xojl6vj">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8299" data-mp="3yi3zarbzn2h">Manejo de efectivo</li>
                  <li data-id="element-8300" data-mp="8w9wa5vw1b77">Confirmación de pagos</li>
                  <li data-id="element-8301" data-mp="8x383l9peqw7">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8302" data-mp="wlcq0c3squi2">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8303" data-mp="10mo5hosyhzcj">
                  <li data-id="element-8304" data-mp="mv18fmr6wmsp">Pagos no recibidos</li>
                  <li data-id="element-8305" data-mp="mu89h7yh31l4">Comprobantes falsos</li>
                  <li data-id="element-8306" data-mp="ru4ffcqqd33b">Errores en montos</li>
                  <li data-id="element-8307" data-mp="rt2sa9wfwq58">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8308" data-mp="1finmxq1yhbuc">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8309" data-mp="1fi466co1kthw">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8310" data-mp="m5q2wgs8cxas">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8311" data-mp="m6j0os97ocgs">
                  <li data-id="element-8312" data-mp="r3hv7bwselfi">Reclamos de clientes</li>
                  <li data-id="element-8313" data-mp="d51ovm2u6wxw">Reembolsos</li>
                  <li data-id="element-8314" data-mp="d5tca9ma5od3">Cancelaciones</li>
                  <li data-id="element-8315" data-mp="d4rttk2xpzlc">Disputas</li>
                  <li data-id="element-8316" data-mp="h6d7h7namhwl">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8317" data-mp="h8py0974a0l9">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8318" data-mp="3pmyg2nc0j8z6">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8319" data-mp="3pnrhd8s7d69x">
              <span className="text-[#006847]" data-id="element-8320" data-mp="3umkw14j873bo">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8321" data-mp="3gmteitti34sx">
              <p data-id="element-8322" data-mp="3go4e0hfwxqe8">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8323" data-mp="3lkbjk94eczvn">
                <li data-id="element-8324" data-mp="3204dgnjlojkf">Responsable</li>
                <li data-id="element-8325" data-mp="31zbew9usp0dd">Legal</li>
                <li data-id="element-8326" data-mp="2wzyk92xomp08">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8327" data-mp="2x1jdmp89g1wi">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8328" data-mp="3azhm5dzwh443">
                <li data-id="element-8329" data-mp="3axep4a0byapv">Publicar información falsa</li>
                <li data-id="element-8330" data-mp="36x35n0jpegfz">Manipular precios de forma engañosa</li>
                <li data-id="element-8331" data-mp="3kxxflnmegpgr">Simular disponibilidad inexistente</li>
                <li data-id="element-8332" data-mp="3kwcns5rgzkml">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8333" data-mp="3fx00jjwosbjh">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8334" data-mp="3unh1l25eszfu">
              <span className="text-[#006847]" data-id="element-8335" data-mp="3ponld1yqmubz">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8336" data-mp="7ircmp5408xn">
              <p data-id="element-8337" data-mp="7jsnotm4kvfd">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8338" data-mp="2kg4qjydk8i2">
                <li data-id="element-8339" data-mp="2i3c9cuzqfqr">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8340" data-mp="2wdh658x4vfif">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8341" data-mp="35cm3wd0vf4tj">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8342" data-mp="35ahp301foleh">
                <li data-id="element-8343" data-mp="3a445926t37f1">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8344" data-mp="3k18fq4raheg0">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8345" data-mp="3k3l7taqrh56s">
                    <li data-id="element-8346" data-mp="3p1wi1mkyxhpj">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8347" data-mp="1unltlf8acpka">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8348" data-mp="1r4mpewfqzd91">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8349" data-mp="1r569aioykbpp">
              <span className="text-[#006847]" data-id="element-8350" data-mp="1me69n5ogffji">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8351" data-mp="1hejvmu0sxv9n">
              <p data-id="element-8352" data-mp="1hfmkkwekdnmx">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8353" data-mp="1de14712tmr7z">
                <li data-id="element-8354" data-mp="2a3iexugnv3gj">Menú digital</li>
                <li data-id="element-8355" data-mp="2a2ft40y73r7h">Gestión de pedidos</li>
                <li data-id="element-8356" data-mp="2a1eclgyeucid">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8357" data-mp="255pap6yx4jiw">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8358" data-mp="212avujmpu971">
                  <p className="font-medium text-white mb-2" data-id="element-8359" data-mp="1w3ptadjzrdff">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8360" data-mp="pnxbhor68bvr">
                    <li data-id="element-8361" data-mp="kokh8ixz02j5">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8362" data-mp="28l8nefjvte5i">
                  <p className="font-medium text-white mb-2" data-id="element-8363" data-mp="28jfib4ox31zm">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8364" data-mp="2ddjsrxxe5s5g">
                    <li data-id="element-8365" data-mp="1zllmduv2eacz">Propiedad del software</li>
                    <li data-id="element-8366" data-mp="1zir3i7rp8xlo">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8367" data-mp="2rbzwdfzyj2jd">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8368" data-mp="2ibl94b3fndd8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8369" data-mp="2ia0gir0oi4i0">
              <span className="text-[#006847]" data-id="element-8370" data-mp="2n9d8trabk3rz">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8371" data-mp="16v3od8976z6f">
              <p data-id="element-8372" data-mp="16y9bwj26ht01">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8373" data-mp="1bv9h6rr7erq3">
                <li data-id="element-8374" data-mp="13dz729bhrp1w">Disponibilidad continua</li>
                <li data-id="element-8375" data-mp="13co42bpvelbu">Funcionamiento sin interrupciones</li>
                <li data-id="element-8376" data-mp="zcnkydrttlyg">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8377" data-mp="zegj14odixuu">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8378" data-mp="1db3t895c7kip">
                <li data-id="element-8379" data-mp="18dbqsl72gg09">Fallas técnicas</li>
                <li data-id="element-8380" data-mp="18edepq96kwze">Actualizaciones</li>
                <li data-id="element-8381" data-mp="18b93wa17n2zr">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8382" data-mp="ko9abgo64t7c">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8383" data-mp="ueviiptk2hg0">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8384" data-mp="ufdq2ilo4i38">
              <span className="text-[#006847]" data-id="element-8385" data-mp="pl9efm1gjlvt">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8386" data-mp="1un9w4qnwjqk">
              <p data-id="element-8387" data-mp="3t42ovpyxvulr">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8388" data-mp="1x0efwuq3cry8">
                <li data-id="element-8389" data-mp="1wy20opbpwvov">No está garantizada permanentemente</li>
                <li data-id="element-8390" data-mp="21xy86yjmj596">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8391" data-mp="26ppo8f55lsl2">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8392" data-mp="26s2fjiwsxfas">
                <li data-id="element-8393" data-mp="2aq9mjm1gr28s">Destacar o no restaurantes</li>
                <li data-id="element-8394" data-mp="1e1adw5wyvyg2">Modificar posiciones</li>
                <li data-id="element-8395" data-mp="1e2lqmv8e4gjb">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8396" data-mp="1j0x0v72lkt22">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8397" data-mp="1j2hk40jgopkm">
              <span className="text-[#006847]" data-id="element-8398" data-mp="1n0noj1wtut2d">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8399" data-mp="1ryp6fjiiomc9">
              <p data-id="element-8400" data-mp="2yhx3bb50gwxc">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8401" data-mp="2yj8bro9eisus">
                <li data-id="element-8402" data-mp="33enk60on3wjt">Cumplir con los pagos acordados</li>
                <li data-id="element-8403" data-mp="3djvv83rt19dd">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8404" data-mp="3dm9me1jd61fn">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8405" data-mp="38lly3nmiryp4">
                <li data-id="element-8406" data-mp="33tkefgn0v5p2">Suspender el servicio</li>
                <li data-id="element-8407" data-mp="33s9c7l986602">Limitar funcionalidades</li>
                <li data-id="element-8408" data-mp="2ztk2q3rb58lp">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8409" data-mp="2utxnxpvtzkas">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8410" data-mp="2uugts887ii8g">
              <span className="text-[#006847]" data-id="element-8411" data-mp="2ptjdk16rby9l">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8412" data-mp="2kwj6bmy68pgw">
              <p data-id="element-8413" data-mp="2kxkm24q4u04y">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8414" data-mp="2gvh6b3wfk9dv">
                <li data-id="element-8415" data-mp="j4emkyqtsyh9">Incumplimiento de términos</li>
                <li data-id="element-8416" data-mp="j20osi4rh860">Uso indebido</li>
                <li data-id="element-8417" data-mp="f203qen5pypz">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8418" data-mp="yb9m7r205k2u">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8419" data-mp="12ephok2c5edy">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8420" data-mp="olq78wheuad9">
              <span className="text-[#006847]" data-id="element-8421" data-mp="tkktk8el6h24">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8422" data-mp="enk46bjvay6t">
              <p data-id="element-8423" data-mp="emit472uqbp3">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8424" data-mp="jmn8fts0x0dq">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8425" data-mp="5nxcwikur8rh">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8426" data-mp="5ogkb5cvmer9">
              <span className="text-[#006847]" data-id="element-8427" data-mp="am8lkpzevd84">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8428" data-mp="1zyk7fpo6hchh">
              <p data-id="element-8429" data-mp="2509ktbyvi28q">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8430" data-mp="24xnax5oifanc">
                <li data-id="element-8431" data-mp="2f4g4u14mmhyx">Pérdidas económicas</li>
                <li data-id="element-8432" data-mp="2a4k4cbv518o4">Daños indirectos</li>
                <li data-id="element-8433" data-mp="2a5mrq9t94sza">Lucro cesante</li>
                <li data-id="element-8434" data-mp="2a2h4l046o167">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8435" data-mp="2ny30zscqxn8n">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8436" data-mp="2j59scte5pura">
              <span className="text-[#006847]" data-id="element-8437" data-mp="2j3fbpr9x4ot0">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8438" data-mp="2sv1q1whjz3zz">
              <p data-id="element-8439" data-mp="2su9vmozozcba">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8440" data-mp="32spr145r57ql">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8441" data-mp="1cgjof9da07xf">
              <span className="text-[#006847]" data-id="element-8442" data-mp="18f80d8a1vurc">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8443" data-mp="fszt4awr6g8r">
              <p className="font-medium" data-id="element-8444" data-mp="frygi2039lox">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8445" data-mp="auogjsf2prmu">
                <li data-id="element-8446" data-mp="pj2w93xl9akt">Ha leído este documento completo</li>
                <li data-id="element-8447" data-mp="phrjiem60shk">Comprende su alcance</li>
                <li data-id="element-8448" data-mp="kjzo3ambao8m">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}